module.exports = __webpack_public_path__ + "img/map_public@2x.514b60e8.png";